import { PageHero } from "@/components/PageHero";
import { AmenitiesBento } from "@/components/AmenitiesBento";

const Amenities = () => (
  <div data-testid="amenities-page">
    <PageHero
      overline="Amenities"
      title={
        <>
          Eighteen reasons to
          <span className="italic text-brand-gold"> stay in.</span>
        </>
      }
      lead="Pools, courts, gardens and a library — each amenity at Exente is designed to bring residents together."
      image="https://images.pexels.com/photos/29149086/pexels-photo-29149086.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650"
    />
    <AmenitiesBento />
  </div>
);

export default Amenities;
